import messages from './netbank-login-identifier-lang.json';
import identifierInput from '../identifier-input/identifier-input.vue';
import accountNumberInput from '../account-number-input/account-number-input.vue';
import passwordInput from '../password-input/password-input.vue';
import { required, minLength } from 'vuelidate/lib/validators';
import netbankLoginFormBase from '../netbank-login-form-base/netbank-login-form-base';
import notStartingWithNumber from '../../../common/js/validators/not-starting-with-number';
import { COOKIE_PORTAL_ID_NAME } from './../../../common/js/constants/constants';
import VueCheckbox from '@ui-common/vue-checkbox';
const COOKIE_USER_DATA_NAME = 'portal-netbank-login-identifier';
const COOKIE_ADDITIONAL_NAME = 'portal-netbank-login-identifier-additional';
export default {
	extends: netbankLoginFormBase,
	data() {
		return {};
	},
	i18n: { messages },
	validations() {
		return {
			model: {
				identifier: {
					required,
					notStartingWithNumber,
					minLength: minLength(9)
				},
				password: {
					required
				}
			}
		};
	},
	props: {
		otpdirektUrl: {
			required: true
		},
		linkError: {
			required: true
		}
	},
	computed: {
		hasEditedError() {
			return this.$slots.default;
		}
	},
	components: {
		identifierInput,
		accountNumberInput,
		passwordInput,
		VueCheckbox
	},
	watch: {
		selectedAccountNumber(val) {
			this.model = val;
		}
	},
	methods: {
		jumpToPassword() {
			this.$refs['password-control'].$refs['password-input'].focus();
		},
		showFieldErrors() {
			this.$v.model.identifier.$touch();
			this.$v.model.password.$touch();

			if (this.$v.model.identifier.$invalid && this.$v.model.password.$invalid) {
				this.$gtm.trackEvent({
					event: 'direktBankLoginFailed',
					loginType: 'personalIdLogin',
					loginDetails: 'invalidForm'
				});
			}
		},
		submitForm() {
			this.$gtm.trackEvent({
				event: 'direktBankLogin',
				loginType: 'personalIdLogin'
			});
			this.$refs.identifier.value = this.model.identifier;
			this.$refs.password.value = this.model.password;
			if (this.structureId) {
				this.$refs.structureId.value = this.structureId;
			}
			let cookieId = this.$cookie.get(COOKIE_PORTAL_ID_NAME);
			this.$refs.cookieId.value = cookieId;
			this.$refs.tranzakcionkentiAzonositas.value = this.model.identifyTransaction ? 'on' : '';
			this.$refs.lang.value = this.$i18n.locale;
			this.$refs.isContextData.value = this.seonData || '';
			this.$refs.hiddenForm.submit();
		}
	},
	created() {
		this.cookiePortalIdName = COOKIE_PORTAL_ID_NAME;
		this.cookieUserDataName = COOKIE_USER_DATA_NAME;
		this.cookieAdditionalName = COOKIE_ADDITIONAL_NAME;
		this.loadCookie();
	}
};
